// FILE: src/components/Partners.js

import React, { useEffect, useRef, useState } from 'react';
import './Partners.css';

const PARTNER_ITEMS = [
  { src: './Images/Partners/AIG.webp',           name: 'AIG' },
  { src: './Images/Partners/Anneux.webp',         name: 'Anneux' },
  { src: './Images/Partners/Athene.webp',         name: 'Athene' },
  { src: './Images/Partners/corebridge.webp',     name: 'Corebridge' },
  { src: './Images/Partners/FG.webp',             name: 'FG' },
  { src: './Images/Partners/HGI.webp',            name: 'HGI' },
  { src: './Images/Partners/Nationwide.webp',     name: 'Nationwide' },
  { src: './Images/Partners/netlaw.webp',         name: 'Netlaw' },
  { src: './Images/Partners/North_America.webp',  name: 'North America' },
];

const CONFIG = {
  cardWidth:    200,
  cardMargin:   16,
  intervalTime: 16,
  step:         1,
  background:   '#ffffff',
};

function Partners() {
  const trackRef     = useRef(null);
  const positionRef  = useRef(0);
  const intervalRef  = useRef(null);
  const [paused, setPaused] = useState(false);

  const totalWidth = PARTNER_ITEMS.length *
    (CONFIG.cardWidth + CONFIG.cardMargin * 2);

  useEffect(() => {
    // ── GUARD 1: stop if paused or element not ready ──
    if (paused || !trackRef.current) return;

    intervalRef.current = setInterval(() => {

      // ── GUARD 2: element could unmount mid-interval ──
      if (!trackRef.current) {
        clearInterval(intervalRef.current);
        return;
      }

      positionRef.current -= CONFIG.step;

      if (Math.abs(positionRef.current) >= totalWidth) {
        positionRef.current = 0;
      }

      trackRef.current.style.transform =
        `translateX(${positionRef.current}px)`;

    }, CONFIG.intervalTime);

    // ── CLEANUP: runs when component unmounts ─────────
    // Without this the interval keeps running after the
    // component is removed, causing the null error.
    return () => {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    };

  }, [paused, totalWidth]);

  return (
    <section className="partners-section">
      <p className="partners-title">Our Trusted Partners</p>

      <div className="partners-track-wrapper">
        <div
          className="partners-track"
          ref={trackRef}
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
        >
          {PARTNER_ITEMS.map((item, i) => (
            <div className="partners-card" key={`a-${i}`}>
              <img
                src={item.src}
                alt={item.name}
                className="partners-card-img"
                onError={e => { e.target.style.display = 'none'; }}
              />
            </div>
          ))}

          {PARTNER_ITEMS.map((item, i) => (
            <div className="partners-card" key={`b-${i}`}>
              <img
                src={item.src}
                alt={item.name}
                className="partners-card-img"
                onError={e => { e.target.style.display = 'none'; }}
              />
            </div>
          ))}
        </div>

        <div className="partners-fade" />
      </div>
    </section>
  );
}

export default Partners;